module.exports = __webpack_public_path__ + "static/media/loyaltyTierGoldBackground.6c915a01.png";